import moment from 'moment';
var ISO_DATE_REGEX = /^(\d{4})-0?(\d+)-0?(\d+)/;
var dateToLocalTime = function (isoString) {
    var _a = ISO_DATE_REGEX.exec(isoString), _ = _a[0], year = _a[1], month = _a[2], day = _a[3];
    return new Date(Number(year), Number(month) - 1, Number(day));
};
var dateTimeToLocalTime = function (isoString) {
    return new Date(isoString);
};
var dateToISODateString = function (date) {
    var MAX_SINGLE_DIGIT_NUMBER = 9;
    var convertIntegerToString = function (int) {
        return int > MAX_SINGLE_DIGIT_NUMBER ? "".concat(int) : "0".concat(int);
    };
    var month = convertIntegerToString(date.getMonth() + 1);
    var day = convertIntegerToString(date.getDate());
    var year = date.getFullYear();
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var dateTimeToISODateString = function (date) {
    return date ? moment(date).format() : '';
};
var datestringsToMoments = function (datestrings) {
    if (datestrings === void 0) { datestrings = []; }
    return datestrings.filter(function (date) { return Boolean(date); }).map(function (date) { return moment(date); });
};
var displayDate = function (datestring) {
    return moment(datestring).format('MMM D, YYYY [at] h:mma');
};
var maxDate = function (datestrings) {
    var moments = datestringsToMoments(datestrings);
    return moments.length ? moment.max(moments).toISOString() : null;
};
var minDate = function (datestrings) {
    var moments = datestringsToMoments(datestrings);
    return moments.length ? moment.min(moments).toISOString() : null;
};
var relativeDate = function (datestring) {
    return moment(datestring).fromNow();
};
export { dateToLocalTime, dateTimeToLocalTime, displayDate, maxDate, minDate, relativeDate, dateToISODateString, dateTimeToISODateString, };
//# sourceMappingURL=dateTimeUtils.js.map